module.exports = __webpack_public_path__ + "img/banner.b0ec0177.png";